<template>
  <div
    :class="[popperClass]"
    :style="{ minWidth: minWidth , maxWidth:maxWidth}"
    class="el-select-dropdown el-popper"
  >
    <slot />
  </div>
</template>

<script type="text/babel">
  import Popper from 'element-ui/src/utils/vue-popper';

  export default {
    name: 'el-select-dropdown',

    componentName: 'ElSelectDropdown',

    mixins: [Popper],

    data() {
      return {
        minWidth: '',
        maxWidth: ''
      };
    },

    computed: {
      popperClass() {
        return this.$parent.popperClass;
      }
    },

    props: {
      placement: {
        default: 'bottom-start',
        type: String
      },

      boundariesPadding: {
        default: 0,
        type: Number
      },

      popperOptions: {
        type: Object,
        default() {
          return {
            gpuAcceleration: false
          };
        }
      },

      visibleArrow: {
        default: true,
        type: Boolean
      },

      appendToBody: {
        type: Boolean,
        default: true
      }
    },

    watch: {
      'minWidth': function (v) {
        // console.log(v)
      }
    },
    mounted() {
      this.referenceElm = this.$parent.$refs.reference.$el;
      this.popperElm = this.$el;
      this.$parent.popperElm = this.popperElm;
      this.minWidth = this.$parent.$el.offsetWidth + 'px';
      this.updatePopper();
    },
    methods: {
      getWidth() {
        this.minWidth = this.$parent.$el.offsetWidth + 'px';
        this.maxWidth = this.$parent.maxWidth ? this.$parent.maxWidth + 'px' : '';
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/select/select-dropdown.vue